module.exports = __webpack_public_path__ + "img/Frame-82.8739850e.svg";